import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { LocalStoreManager } from './local-store-manager.service';
import { DBkeys } from './db-keys';
import { Utilities } from './utilities';
import { environment } from '../../environments/environment';

interface UserConfiguration {
    homeUrl: string;
}

@Injectable()
export class ConfigurationService {
    constructor(private localStorage: LocalStoreManager) {
        this.loadLocalChanges();
    }

    set homeUrl(value: string) {
        this._homeUrl = value;
        this.saveToLocalStore(value, DBkeys.HOME_URL);
    }

    get homeUrl() {
        return this._homeUrl || ConfigurationService.defaultHomeUrl;
    }

    public static readonly appVersion: string = '4.0.0';

    public static readonly defaultHomeUrl: string = '/';

    public baseUrl = environment.baseUrl || Utilities.baseUrl();

    public tokenUrl = environment.tokenUrl || environment.baseUrl || Utilities.baseUrl();

    public loginUrl = environment.loginUrl;

    public fallbackBaseUrl = 'https://ExcWebBack.ebenmonney.com';

    private _homeUrl: string = null;

    private onConfigurationImported: Subject<boolean> = new Subject<boolean>();

    configurationImported$ = this.onConfigurationImported.asObservable();

    private loadLocalChanges() {
        if (this.localStorage.exists(DBkeys.HOME_URL)) {
            this._homeUrl = this.localStorage.getDataObject<string>(DBkeys.HOME_URL);
        }
    }

    private saveToLocalStore(data: any, key: string) {
        setTimeout(() => this.localStorage.savePermanentData(data, key));
    }

    public import(jsonValue: string) {
        this.clearLocalChanges();
        if (jsonValue) {
            const importValue: UserConfiguration = Utilities.JsonTryParse(jsonValue);
            if (importValue.homeUrl != null) {
                this.homeUrl = importValue.homeUrl;
            }
        }
        this.onConfigurationImported.next();
    }

    public export(changesOnly = true): string {
        const exportValue: any = {
            homeUrl: changesOnly ? this._homeUrl : this.homeUrl,
        };
        return JSON.stringify(exportValue);
    }

    public clearLocalChanges() {
        this._homeUrl = null;
        this.localStorage.deleteData(DBkeys.HOME_URL);
    }
}
